<div class="fc-time-input" [class.invalid]="control.enabled && (control.errors || hasGroupError)">
  <div class="fc-time-input__infix" [class.fc-time-input__infix--filled]="control.value">
    <label *ngIf="showLabel" class="fc-time-input__infix-label" (click)="input.focus()">
      <span *ngIf="!label" class="dafaultTitle">{{ 'FC_TIME_INPUT.LABEL' | translate }}</span>
      <span *ngIf="label">{{ label }}</span>
      <span *ngIf="required" class="requiredSymbol">*</span>
    </label>
    <input
      #input
      class="fc-time-input__infix-input"
      [class.fc-time-input__infix-input--centered]="textCentered"
      tabindex="-1"
      mask="Hh:m0"
      [(formControl)]="control"
      [placeholder]="placeholder"
    />
    <small class="fc-time-input__infix-error" *ngIf="!hasCustomErrors && control.errors && !hasGroupError">
      {{ translateErrorPrefix + '.' + errorMessage | translate }}
    </small>
    <small class="fc-time-input__infix-error fc-time-input__infix-error--custom" *ngIf="hasCustomErrors">
      <ng-content></ng-content>
    </small>
  </div>
  <div *ngIf="showIcon" class="fc-time-input__suffix">
    <mat-icon [ngClass]="colorTimeIcon ? 'icon-valid' : 'icon-not-valid'">schedule</mat-icon>
  </div>
</div>
